import { render, staticRenderFns } from "./SocialEmployeesForm.vue?vue&type=template&id=0d66a3ae&scoped=true&lang=html&"
import script from "./SocialEmployeesForm.vue?vue&type=script&lang=js&"
export * from "./SocialEmployeesForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialEmployeesForm.vue?vue&type=style&index=0&id=0d66a3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d66a3ae",
  null
  
)

export default component.exports